import _ from "lodash";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AddEditParcel } from "../../components/addParcel/AddEditParcel";
import Page from "../../components/page/Page";
import { useBreadcrumbs } from "../../features/breadcrumbs/hooks";
import PageHeader from "../../features/page-header/PageHeader";

export const AddEditParcelPage: React.FC = () => {
    const { pathname } = useLocation();
    const location = useLocation();
    const [onEditParcel] = useState(pathname.split("/").splice(-1)[0] === "edit-parcel");
    const title = onEditParcel ? "Edit parcel " : "Add parcel";
    const propertyArtifactId = _.get(
        location.state?.data,
        "artifactDetails.association.parcelAssociation.associatedPropertyArtifactId"
    );
    const { updateBreadcrumbs } = useBreadcrumbs();
    const propertyNumber = _.get(location.state?.data, "artifactDetails.propertyNumber");
    const parcelArtifactId = location.state?.artifactId;
    const parcelPropertyNumber = location.state?.propertyNumber;

    useEffect(() => {
        updateBreadcrumbs(
            [
                { text: "Home", href: "/" },
                propertyArtifactId
                    ? {
                          text: _.truncate(propertyNumber, { length: 15 }),
                          href: `/property-details/${propertyArtifactId}`,
                      }
                    : undefined,
                parcelPropertyNumber || parcelArtifactId
                    ? {
                          text: _.truncate(parcelPropertyNumber, { length: 15 }),
                          href: `/property-details/${parcelArtifactId}`,
                      }
                    : undefined,
                {
                    text: title,
                    href: "",
                },
            ].filter(Boolean)
        );
    }, []);

    return (
        <Page type="form" title={title} hasBreadcrumbs={false}>
            <PageHeader />
            <AddEditParcel />
        </Page>
    );
};
